import * as angular from "angular";
import {IController} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";

export class billingAccountViewCtrl implements IController {

  billingAccount:any;
  currencySymbol:any;

  isSideNavExpended: boolean = true;

  constructor(private splitService: SplitService, private $mdSidenav) {
  }

  $onInit() {
    this.currencySymbol = this.splitService.getCurrencySymbol();
  }

  toggleSidenav(event) {
    this.isSideNavExpended = true;
    this.$mdSidenav('billing-account-sidenav').toggle();
  }

  onToggleSideNavExpend() {
    this.isSideNavExpended = !this.isSideNavExpended;
  }

  onBillingAccountChange(updatedBillingAccount) {
    this.billingAccount = updatedBillingAccount;
  }
}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingAccount', {
    bindings: {
      billingAccount: '<'
    },
    template: require('./billing-account.html').default,
    controller: billingAccountViewCtrl
  });
